const SET_MARKETPLACE_SPS = {
  START: 'SET_MARKETPLACE_SPS_START',
  SUCCESS: 'SET_MARKETPLACE_SPS_SUCCESS',
  ERROR: 'SET_MARKETPLACE_SPS_ERROR',
};

export default SET_MARKETPLACE_SPS;
